<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-addresses-page" [class.marginbottom]="!isCreateOrder">

  <!-- TOP HEADER -->
  <section class="vcash-top" *ngIf="!isCreateOrder">
    <div class="vcash-appbar">
      <button class="appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="appbar-title">
        {{ isCreateOrder ? ('Select Address' | transloco) : ('myaddresses' | transloco) }}
      </h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY CARD -->
    <section class="address-summary-card" *ngIf="!isCreateOrder">
      <div class="address-summary-left">
        <span class="address-overline">
          {{ isCreateOrder ? ('Select Address' | transloco) : ('myaddresses' | transloco) }}
        </span>

        <h2>{{ addresses?.length || 0 }}</h2>

        <p>
          @if(isCreateOrder){
          {{ 'Choose the delivery address for your order' | transloco }}
          }
          @else{
          {{ 'Manage your saved addresses easily' | transloco }}
          }
        </p>
      </div>

      <div class="address-summary-action" routerLink="/addaddress">
        <span>+</span>
      </div>
    </section>

    <!-- ADDRESS LIST -->
    @if(addresses.length > 0){
    <section class="addresses-card" [class.margintop]="isCreateOrder">
      <div class="list-wrap">

        <div class="address-item" [class.pointer]="isCreateOrder" [class.active]="selectedAddress?.id === item.id"
          *ngFor="let item of addresses; let isFirst = first" (click)="chooseAddress(item)">

          <!-- NORMAL MODE -->
          @if(!isCreateOrder){
          <div class="address-item__top">
            <div class="address-item__title-side">
              <div class="address-icon-box">
                <img class="address-main-icon" src="/assets/e-commerce/icons/54.webp" alt="address">
              </div>

              <div class="address-title-group">
                <div class="label">{{ item.address_title }}</div>
                <div class="meta">
                  {{ item.city.city_name_ar }}, {{ item.government.governorate_name_ar }}
                </div>
              </div>
            </div>

            <div class="address-item__actions">
              <button type="button" class="delete-btn pointer" (click)="delete(item.id); $event.stopPropagation()"
                aria-label="Delete address">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>

          <div class="address-item__body">
            <p class="details">
              {{ item.address }}
            </p>

            @if(item.location_link){
            <a [href]="item.location_link" target="_blank" class="map-link" (click)="$event.stopPropagation()">
              {{ "Google Maps Link" | transloco }}
            </a>
            }
          </div>
          }
          @else{
          <div class="address-item__top create-mode">
            <div class="address-item__title-side">
              <div class="address-icon-box">
                <img class="address-main-icon" src="/assets/e-commerce/icons/02_address.svg" alt="address">
              </div>

              <div class="address-title-group">
                <div class="label">{{ item.address_title }}</div>
                <div class="meta">
                  {{ item.city.city_name_ar }}, {{ item.government.governorate_name_ar }}
                </div>
                <p class="details inline-details">
                  {{ item.address }}
                </p>
              </div>
            </div>

            <div class="selected-badge" *ngIf="selectedAddress?.id === item.id">
              {{ "selected" | transloco }}
            </div>
          </div>

          @if(isFirst){
          <div class="add-new-row">
            <button type="button" class="mini-add-btn" routerLink="/addaddress" (click)="$event.stopPropagation()">
              + {{ "new Address" | transloco }}
            </button>
          </div>
          }
          }

        </div>

      </div>

      @if(!isCreateOrder){
      <div class="bottom-action">
        <button class="checkout-btn" routerLink="/addaddress">
          {{ "Add Address" | transloco }}
        </button>
      </div>
      }
    </section>
    }
    @else {
    <app-emptyaddresses *ngIf="!contentReady"></app-emptyaddresses>
    }

  </div>
</div>